import React, { useState, useEffect } from "react";
import {useNavigate } from "react-router-dom";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import "./Spinner.css";
import "react-toastify/dist/ReactToastify.css";
import { Modal, Button, Form } from "react-bootstrap";

const PemeAppointmentCancel = ({ isOpen, onRequestClose, appointment }) => {

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const cancelAppointment = async (appointmentId) => {
    const token = JSON.parse(localStorage.getItem("data")).token;
    setLoading(true);
    try {
      await axios.post(
        "/api/peme-appointment/cancel",
        {
          id: `${appointmentId}`,
          appointmentstatus: "APPOINTMENT CANCELLED",
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      toast.success("Appointment cancelled successfully.");
      onRequestClose(); // Close the modal
    } catch (error) {
    setLoading(false);
      handleError(error);
 
    }
  };

  const handleConfirmCancel = async () => {
    
      cancelAppointment(appointment.id);
 
  };

 
  const handleError = (error) => {
    if (error.response) {
      // Check if the server responded with an error
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        // Display the error message if it exists
        toast.error(error.response.data.message);
      } else if (error.response.data && typeof error.response.data === 'string') {
        // If the error message is a plain string (like Razorpay's "BAD_REQUEST_ERROR")
        toast.error(error.response.data);
      } else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      } else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      // If the error has a message (general JS error)
      toast.error(error.message);
    } else {
      // Fallback error
      toast.error("An error occurred.");
    }
  };
  
  return (
    <Modal show={isOpen} onHide={onRequestClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>
        Cancel PEME Appointment</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading && <div className="loading"></div>}
        <div className="col-xl-10 mx-xl-auto">
          <div className="card card-raised mb-2">
            <div className="card-body p-4">
              <p>Are you sure you want to cancel this appointment?</p>

              <div className="d-flex justify-content-end mt-2">
                <Button variant="secondary" onClick={onRequestClose}>
                  Close
                </Button>
                <Button
                  variant="danger"
                  onClick={handleConfirmCancel}
                  style={{ marginLeft: '10px' }}
                >
                      Confirm
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default PemeAppointmentCancel;
